import type { SDKState } from "@/state/sdk-state";
import { joinURL } from "@/utils/url";
import { Logger } from "@/utils/logger";

export class ApiService {
  #state: SDKState;
  #logger: Logger;

  constructor(state: SDKState, logger: Logger) {
    this.#state = state;
    this.#logger = logger.extend(this.constructor.name);
  }

  private async fetch(
    endpoint: string,
    method: "GET" | "POST",
    body?: Record<string, any>,
  ) {
    const url = joinURL(this.#state.options.apiBase, "public", endpoint);
    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        "x-app-id": this.#state.options.clientId,
      },
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      throw new Error(this.#logger.prefixMessage(`Failed to fetch ${url}`));
    }

    return response.json();
  }

  async GET(endpoint: string) {
    return this.fetch(endpoint, "GET");
  }

  async POST(endpoint: string, body: Record<string, any>) {
    return this.fetch(endpoint, "POST", body);
  }
}
